/**
 * group-validation.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";

type MessageFn = (v : any) => string;
type VMessage = string | MessageFn;

@Component({
    selector: "group-validation",
    template: `
        <div *ngFor="let c of (group.controls | entries)">
            <div *ngIf="c[1].errors">
                <label>{{c[0]}}:</label>
                <validation-messages [control]="c[1]"></validation-messages>
            </div>
            <template [ngIf]="array(c[1])">
                <div *ngFor="let r of c[1].controls; let i = index">
                    <template [ngIf]="r.errors">
                        <label>{{c[0]}} #{{i+1}}:</label>
                        <validation-messages [control]="r">
                        </validation-messages>
                    </template>
                </div>
            </template>
        </div>
    `,
    styles: [``]
})
export class GroupValidationComponent
{
    @Input()
    public group : FormGroup;

    @Input()
    public groupLabel : string = "Table";

    public array (control : AbstractControl) : control is FormArray
    {
        return (control instanceof FormArray);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/controls/group-validation.component.ts